import React, {useState,useEffect} from 'react'
import { getLastOrder } from 'network/ApiAxiosTickets';
import { Button, Container, Card, CardBody, CardFooter, CardHeader, Row, Label, Input } from 'reactstrap';
import { updateOrder } from 'network/ApiAxiosTickets';

function LastOrder() {
    useEffect(() => {
        fetchLastOrder()
    }, []);

    const [clientName, setClientName] = useState('');
    const [clientPhone, setClientPhone] = useState('');
    const [clientOrder, setClientOrder] = useState('');
    const [clientTotal, setClientTotal] = useState('');
    const [orderId, setOrderId] = useState('');
    const [notice, setNotice] = useState({});

    const sellerId = JSON.parse(localStorage.getItem('user'))._id

    const fetchLastOrder = async() =>{
        const resp = await getLastOrder(sellerId)
        if(resp.data.success){
            const {doc} = resp.data
            setClientName(doc.clientName)
            setClientPhone(doc.phone)
            setClientTotal(doc.total)
            setOrderId(doc._id)
            setClientOrder(resp.data.cart)
        }
    }

    const handleSave = async()=>{
        const resp = await updateOrder(orderId,clientName,clientPhone)
        if(resp.data.success){
            setNotice({
                textColor : 'text-blue bg-grey mb-2',
                text: 'Message Sent'
            })
            handleNotice()
        }else{
            setNotice({
                textColor : 'text-white bg-red mb-2',
                text: 'Something went wrong please refresh the page and try again'
            })
            handleNotice()
        }
    }

    const handleNotice = ()=>{
        setInterval(() => {
            setNotice({})
        }, 3000);
    }

  return (
    <>
        <Container>
            {notice && <span className={notice.textColor}> {notice.text}</span>}
            {clientOrder ? <>
                <Row>
                    <Label>
                        Name: 
                    </Label>
                    <Input type='text' value={clientName} onChange={(e)=> setClientName(e.target.value)}/>
                </Row>
                <Row>
                    <Label>
                        Phone: 
                    </Label>
                    <Input type='number' value={clientPhone} onChange={(e)=> setClientPhone(e.target.value)}/>
                </Row>
                <Row>
                    <Label>
                        Order Total:
                    </Label>
                    {clientTotal}
                </Row>
                <Row>
                    <Label>
                        Order: 
                    </Label>
                    {clientOrder && clientOrder.map((orderItem)=> {
                        return orderItem
                    })}
                </Row>
                <Row>
                    <Button onClick={()=> handleSave()}>Save & Send</Button>
                </Row>
            </> : null}
        
        </Container>
    </>
  )
}

export default LastOrder